import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";
import {useState} from "react";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {FormContainer} from "../../../../palette/Palette";
import Form, {
    ButtonItem,
    GroupItem,
    SimpleItem,
    EmailRule,
    RequiredRule,
    CompareRule,
    Label,
    StringLengthRule
} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {db} from '../../../../firebase/Firebase'
import {useHistory} from "react-router-dom";
import {inject, observer} from "mobx-react";
import axios from "axios"
import {
    ErrorMessage,
    NotiStackInfo
} from "../../../../palette/NotiStackInfo";

const dataMail = {email: ''}

const dataPassword = {password: '', confirm: ''}

const updateEmailUrl = 'https://users-easi4xatjq-uc.a.run.app/update-email'
const updatePwd = 'https://users-easi4xatjq-uc.a.run.app/update-pwd'

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
}


function UserProfile(props) {

    const {companyName, role, idCompany, userMail, userUid} = props.DataStore

    const {enqueueSnackbar} = useSnackbar();

    let history = useHistory();

    const [load, setLoad] = useState(true)
    const [textLoad, setTextLoad] = useState('Cargando...')
    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess,
        text: 'Actualizar correo',
        icon: 'far fa-envelope'
    })
    const [submitButtonPwd, setSubmitButtonPwd] = useState({
        ...buttonSuccess,
        text: 'Actualizar contraseña',
        icon: 'fas fa-key'
    })

    const passwordComparison = () => {
        return dataPassword.password;
    }

    const handleSubmitUpdateMail = async (e) => {
        e.preventDefault();

        setSubmitButton({...submitButton, disabled: true, text: 'Actualizando...'})
        setLoad(false)
        setTextLoad('Actualizando correo electrónico...')

        const data = {...dataMail, oldEmail: userMail, companyName: companyName, role: role}

        await axios.post(updateEmailUrl, data, {headers: headers})
            .then(async (res) => {
                if (res.data === 'OK') {
                    if (role === 'sroot') {
                        await db.collection(companyName).doc(idCompany).update({
                            email: data.email
                        }).then(async () => {
                            await db.collection("Users").doc(idCompany).update({
                                userEmail: data.email
                            }).then(() => {
                                setSubmitButton({...submitButton, disabled: false})
                                setLoad(true)
                                history.push('/')
                                NotiStackInfo('Correo electrónico actualizado', 'success', enqueueSnackbar)
                                NotiStackInfo('Vuelva a iniciar la sesión', 'info', enqueueSnackbar)
                            }).catch(() => {
                                setLoad(true)
                                setSubmitButton({...submitButton, disabled: false})
                                history.push('/')
                            })
                        })
                    } else {

                        await db.collection("Users").doc(userUid).update({
                            userEmail: data.email
                        }).then(() => {
                            setSubmitButton({...submitButton, disabled: false})
                            history.push('/')
                            setLoad(true)
                            NotiStackInfo('Correo electrónico actualizado', 'success', enqueueSnackbar)
                            NotiStackInfo('Vuelva a iniciar la sesión', 'info', enqueueSnackbar)
                        }).catch(() => {
                            setLoad(true)
                            setSubmitButton({...submitButton, disabled: false})
                            history.push('/')
                        })
                    }
                }
            }).catch(() => {
                setLoad(true)
                setSubmitButton({...submitButton, disabled: false})
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })


    }

    const handleSubmitUpdatePassword = async (e) => {
        e.preventDefault()

        setSubmitButtonPwd({...submitButtonPwd, disabled: true, text: 'Actualizando...'})
        setLoad(false)
        setTextLoad('Actualizando contraseña...')

        const data = {...dataPassword, email: userMail}

        await axios.post(updatePwd, data, {headers: headers})
            .then((res) => {
                if (res.data === 'OK') {
                    setSubmitButtonPwd({...submitButtonPwd, disabled: false,})
                    history.push('/')
                    setLoad(true)
                    NotiStackInfo('Contraseña actualizada', 'success', enqueueSnackbar)
                    NotiStackInfo('Vuelva a iniciar la sesión', 'info', enqueueSnackbar)
                } else {
                    setLoad(true)
                    setSubmitButtonPwd({...submitButtonPwd, disabled: false,})
                    history.push('/')
                }
            }).catch(() => {
                setLoad(true)
                setSubmitButtonPwd({...submitButtonPwd, disabled: false,})
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="user-profile-container">
                <HeaderPage icon={'fas fa-user-edit'} text={'Perfil de usuario'} load={load}
                            textLoad={textLoad}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmitUpdateMail}>
                        <Form
                            formData={dataMail}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="update"
                        >
                            <GroupItem caption="Actualizar correo electrónico" colCount={1} colSpan={1}>
                                <SimpleItem dataField={'email'} label={{text: 'Email'}}
                                            editorOptions={{value: userMail, disabled: true}}/>
                                <SimpleItem dataField="email" label={{text: 'Correo electrónico nuevo'}}
                                            editorOptions={{value: '', maxLength: 70}}>
                                    <RequiredRule message="Ingrese el nuevo correo electrónico"/>
                                    <EmailRule message="Correo electrónico invalido"/>
                                </SimpleItem>
                            </GroupItem>
                            <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}
                            />
                        </Form>
                    </form>
                </FormContainer>
                <VerticalSpace spaces={15}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmitUpdatePassword}>
                        <Form
                            formData={dataPassword}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="updatePwd"
                        >
                            <GroupItem caption="Actualizar contraseña" colCount={1} colSpan={1}>
                                <SimpleItem dataField={'password'} label={{text: 'Contraseña'}}
                                            editorOptions={{value: '**********', disabled: true}}/>
                                <SimpleItem dataField="password" label={{text: 'Nueva contraseña'}}
                                            editorOptions={{value: '', mode: 'password'}}>
                                    <RequiredRule message="Ingrese la nueva contraseña"/>
                                    <StringLengthRule message="La contraseña debe tener entre 6 y 10caracteres" min={6}
                                                      max={10}/>
                                </SimpleItem>

                                <SimpleItem dataField="confirm" editorType="dxTextBox" editorOptions={{mode: 'password'}}>
                                    <Label text="Confirmar contraseña"/>
                                    <RequiredRule message="Confirmacion requerida"/>
                                    <CompareRule
                                        message="Las contraseñas no coinciden"
                                        comparisonTarget={passwordComparison}
                                    />
                                </SimpleItem>
                            </GroupItem>
                            <ButtonItem horizontalAlignment="right" buttonOptions={submitButtonPwd}
                            />
                        </Form>
                    </form>
                </FormContainer>

            </div>
        </>
    )
}

export default inject('DataStore')(observer(UserProfile));